import { LoginStrategy } from './strategies/types'
import { useLoginStrategy } from './strategies/useLoginStrategy'

type StrategyLoginFormProps = {
  strategy: LoginStrategy
}

export const StrategyLoginForm = ({ strategy }: StrategyLoginFormProps) => {
  const { currentStep, goToNextStep, goToPreviousStep, updateStepData, stepData } =
    useLoginStrategy(strategy)

  if (!currentStep) {
    return null
  }

  const StepComponent = currentStep.component

  const handleNext = (data: Record<string, unknown>) => {
    updateStepData(data)
    goToNextStep()
  }

  return <StepComponent onNext={handleNext} onBack={goToPreviousStep} stepData={stepData} />
}
